var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}const _=require('pulsar-utils/dist-es6/_');let

BaseAxisController=function(){_createClass(BaseAxisController,[{key:'$inject',get:function()
{return['$scope']}}]);

function BaseAxisController($scope){var _this=this;_classCallCheck(this,BaseAxisController);
if(this.orientation!=='vertical'&&this.orientation!=='horizontal'){
throw new Error('must specify orientation of \'vertical\' or \'horizontal\'');
}

this.myself=this;
this._lengthOnScreen=null;
this._scale=null;
this._range=null;

$scope.$watch('controller.plotArea',function(newPlotArea){
if(_.exists(newPlotArea)){
newPlotArea.registerAxis(_this);
}
});

this.offset=this.offset||0;
}BaseAxisController.prototype.































_updateScale=function _updateScale(){
if(_.exists(this.domain)&&_.exists(this._range)){
this._scale=this._scaleCreator.domain([this.domain.start,this.domain.end]).range([this._range.start,this._range.end]);
}else
{
this._scale=null;
}
};_createClass(BaseAxisController,[{key:'_scaleCreator',get:function(){throw new Error('implement this!')}},{key:'scale',get:function(){return this._scale}},{key:'lengthOnScreen',get:function(){return this._lengthOnScreen},set:function(newLength){if(newLength===this._lengthOnScreen){return}this._lengthOnScreen=newLength;switch(this.orientation){case'horizontal':this._range={start:this.offset,end:newLength+this.offset};break;case'vertical':this._range={start:newLength+this.offset,end:this.offset};break;}this._updateScale()}}]);return BaseAxisController}();


module.exports=BaseAxisController;
//# sourceMappingURL=baseAxisController.js.map
